






























































































































import { Component, Vue } from 'vue-property-decorator';
import StSearch from '@/components/basic/StSearch.vue';
import StToggle from '@/components/basic/StToggle.vue';
import { ListParameters, OutgoingInvoiceFilter, OutgoingInvoiceViewModel, TimeEntryFilter, TimeEntryListSettingsModel } from '@/services/api/nswag/stapiclient_generated';
import { outgoingInvoiceApi, stListApi } from '@/services/st-api';
import { UserStore } from '@/store/user-module';
import { DateTime } from 'luxon';
import { padZero } from '@/utlitities/helper';
import OutgoingInvoiceExport from '@/views/OutgoingInvoice/OutgoingInvoiceExport.vue';
//@ts-ignore
import * as FileSaver from 'file-saver';
import StBadge from '@/components/basic/StBadge.vue';

@Component({
  components: {
    StSearch,
    StToggle,
    OutgoingInvoiceExport,
    StBadge,
  },
})
export default class OutgoingInvoiceList extends Vue {
  search: string = '';
  delLoading: boolean = false;
  printLoadingId = -1;
  printActivityLoadingId = -1;
  showArchived: boolean = false;
  invoices: OutgoingInvoiceViewModel[] = [];
  filter: OutgoingInvoiceFilter = OutgoingInvoiceFilter.fromJS({});

  loading = false;
  delayLoading = false;

  previewIds: number[] = [];

  get currency() {
    return UserStore.userSettings.currency;
  }

  get selectedDate() {
    let isoStr = this.filter.year + '-' + padZero(this.filter.month!) + '-01';
    return DateTime.fromISO(isoStr);
  }

  get filteredInvoices() {
    return this.invoices.filter((_) => {
      return _.title?.toLowerCase().indexOf(this.search.toLowerCase()) != -1 || _.invoiceNo?.toLowerCase().indexOf(this.search.toLowerCase()) != -1;
    });
  }

  getStatusString(model: OutgoingInvoiceViewModel) {
    return this.$t(model.currentStatus?.statusTranslationString ?? '');
  }

  created() {
    this.filter = OutgoingInvoiceFilter.fromJS({
      year: parseInt(this.$route.params?.year ?? UserStore.userNowDateTime.year.toString()),
      month: parseInt(this.$route.params?.month ?? UserStore.userNowDateTime.month.toString()),
    });
  }

  async mounted() {
    try {
      this.loading = true;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  showPreview(id: number) {
    return this.previewIds.some((x) => x == id);
  }

  togglePreview(id: number) {
    if (this.showPreview(id)) {
      this.previewIds.splice(
        this.previewIds.findIndex((x) => x == id),
        1
      );
    } else {
      this.previewIds.push(id);
    }
  }

  async printPdf(invoice: OutgoingInvoiceViewModel) {
    try {
      this.printLoadingId = invoice.id!;
      let result = await outgoingInvoiceApi.getPdf(invoice.id ?? 0);
      FileSaver.saveAs(result.data, this.$t('Rechnung').toString() + '_' + invoice.invoiceNo + '.pdf');
    } finally {
      this.printLoadingId = -1;
    }
  }

  async printActivityReport(invoice: OutgoingInvoiceViewModel) {
    try {
      this.printActivityLoadingId = invoice.id!;

      let result = await outgoingInvoiceApi.getActivityReport(invoice.id!);
      FileSaver.saveAs(result.data, this.$t('Leistungsnachweis').toString() + '_' + invoice.invoiceNo + '.pdf');
    } finally {
      this.printActivityLoadingId = -1;
    }
  }

  async loadData() {
    this.invoices = await outgoingInvoiceApi.getList(this.filter);
  }

  async goToToday() {
    try {
      this.loading = true;
      this.filter.year = UserStore.userNowDateTime.year;
      this.filter.month = UserStore.userNowDateTime.month;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  async switchDate(newDate: string) {
    try {
      this.loading = true;
      let newDateTime = DateTime.fromISO(newDate);
      this.filter.year = newDateTime.year;
      this.filter.month = newDateTime.month;
      await this.loadData();
    } finally {
      this.loading = false;
    }
  }

  async switchMonth(delta: number) {
    try {
      this.loading = true;
      let newDate = this.selectedDate.plus({ months: delta });

      if (this.filter.year) {
        this.filter.year = newDate.year;
        this.filter.month = newDate.month;
        await this.loadData();
      }
    } finally {
      this.loading = false;
    }
  }

  async deleteInvoice(id: number) {
    try {
      this.delLoading = true;
      await outgoingInvoiceApi.delete(id);
      await this.loadData();
    } finally {
      this.delLoading = false;
    }
  }

  editInvoice(id: number) {
    if (this.delLoading) {
      return;
    }
    this.$router.push({
      name: 'OutgoingInvoiceEdit',
      params: { id: id.toString(), year: this.filter.year!.toString(), month: this.filter.month!.toString() },
    });
  }
}
